/**
 * True when the catalog row is the generic "Other" transport provider / carrier.
 * Match by display name only (ids differ per environment).
 */
export function isOtherTransportProvider(
  provider: { title?: string; courier_name?: string } | null | undefined
): boolean {
  if (!provider) return false;
  const raw = (provider.title ?? provider.courier_name ?? '').trim();
  return raw.toLowerCase() === 'other';
}
